/* NgRx */
import {createAction, props} from '@ngrx/store';
import {QuestionnaireModel} from "../../../../models/questionnaire.model";
import {
  CreateSurveyScheduleDetails,
  FetchManageSurveyListResponse,
  FetchMyQuestionnairesListModel,
  QuestionnaireDetails,
  SurveyReviewDetails
} from "../models/fetch-questionnaires-list.model";
import {DropdownOption} from "../../../../models/dropdown-option.model";


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[questionnaires] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** FETCH QUESTIONNAIRE LIST ***********/
const FETCH_QUESTIONNAIRES_LIST_REQUEST = '[questionnaires] fetch questionnaires list requested';
export const FetchQuestionnairesListRequest = createAction(FETCH_QUESTIONNAIRES_LIST_REQUEST, props<{
  userId?: number
}>());

const FETCH_QUESTIONNAIRES_LIST_SUCCESS = '[questionnaires] fetch questionnaires list successful';
export const FetchQuestionnairesListSuccess = createAction(FETCH_QUESTIONNAIRES_LIST_SUCCESS, props<{
  questionnairesList: QuestionnaireModel[]
  message: string
}>());

const FETCH_QUESTIONNAIRES_LIST_FAILURE = '[questionnaires] fetch questionnaires list failure';
export const FetchQuestionnairesListFailure = createAction(FETCH_QUESTIONNAIRES_LIST_FAILURE);

//fetch my questionnaires list
const FETCH_MY_QUESTIONNAIRES_LIST_REQUEST = '[questionnaires] fetch my questionnaires list request'
export const FetchMyQuestionnairesListRequest = createAction(FETCH_MY_QUESTIONNAIRES_LIST_REQUEST, props<{
  payload: {
    pageNumber: number,
    searchText?: string,
    sortColumn?: string,
    sortOrder?: number
  }
}>())

const FETCH_MY_QUESTIONNAIRES_LIST_SUCCESS = '[questionnaires] fetch my questionnaires list success'
export const FetchMyQuestionnairesListSuccess = createAction(FETCH_MY_QUESTIONNAIRES_LIST_SUCCESS, props<{ payload: FetchMyQuestionnairesListModel['response']['data'] }>())

const FETCH_MY_QUESTIONNAIRES_LIST_FAILURE = '[questionnaires] fetch my questionnaires list failure'
export const FetchMyQuestionnairesListFailure = createAction(FETCH_MY_QUESTIONNAIRES_LIST_FAILURE)


//fetch my questionnaires Details
const FETCH_MY_QUESTIONNAIRES_DETAILS_REQUEST = '[questionnaires] fetch my questionnaires details request'
export const FetchMyQuestionnairesDetailsRequest = createAction(FETCH_MY_QUESTIONNAIRES_DETAILS_REQUEST, props<{ payload: { surveyId: string } }>())

const FETCH_MY_QUESTIONNAIRES_DETAILS_SUCCESS = '[questionnaires] fetch my questionnaires details success'
export const FetchMyQuestionnairesDetailsSuccess = createAction(FETCH_MY_QUESTIONNAIRES_DETAILS_SUCCESS, props<{ payload: { details: QuestionnaireDetails } }>())

const FETCH_MY_QUESTIONNAIRES_DETAILS_FAILURE = '[questionnaires] fetch my questionnaires details failure'
export const FetchMyQuestionnairesDetailsFailure = createAction(FETCH_MY_QUESTIONNAIRES_DETAILS_FAILURE)


//fetch survey review questions
const FETCH_REVIEW_SURVEY_DETAILS_REQUEST = '[questionnaires] fetch review survey details request'
export const FetchReviewSurveyDetailsRequest = createAction(FETCH_REVIEW_SURVEY_DETAILS_REQUEST, props<{ payload: { surveyId: string } }>())

const FETCH_REVIEW_SURVEY_DETAILS_SUCCESS = '[questionnaires] fetch review survey details success'
export const FetchReviewSurveyDetailsSuccess = createAction(FETCH_REVIEW_SURVEY_DETAILS_SUCCESS, props<{ payload: { surveyDetails: SurveyReviewDetails } }>())

const FETCH_REVIEW_SURVEY_DETAILS_FAILURE = '[questionnaires] fetch review survey details failure'
export const FetchReviewSurveyDetailsFailure = createAction(FETCH_REVIEW_SURVEY_DETAILS_FAILURE,)

//fetch edit survey Summary data

const FETCH_EDIT_SURVEY_SUMMARY_DETAILS_REQUEST = '[questionnaires] fetch edit survey summary details request'

export const FetchEditSurveySummaryDetailsRequest = createAction(FETCH_EDIT_SURVEY_SUMMARY_DETAILS_REQUEST, props<{ payload: { surveyId: string, searchText?: string } }>())

const FETCH_EDIT_SURVEY_SUMMARY_DETAILS_SUCCESS = '[questionnaires] fetch edit survey summary details success'

export const FetchEditSurveySummaryDetailsSuccess = createAction(FETCH_EDIT_SURVEY_SUMMARY_DETAILS_SUCCESS, props<{ payload: { respondents: any[], pending: any[] } }>())

const FETCH_EDIT_SURVEY_SUMMARY_DETAILS_FAILURE = '[questionnaires] fetch edit survey summary details failure'

export const FetchEditSurveySummaryDetailsFailure = createAction(FETCH_EDIT_SURVEY_SUMMARY_DETAILS_FAILURE)

//fetch survey list
const FETCH_MANAGE_SURVEY_LIST_REQUEST = '[questionnaires] fetch manage survey list request';
export const FetchManageSurveyListRequest = createAction(FETCH_MANAGE_SURVEY_LIST_REQUEST, props<{
  payload: {
    pageNumber: number,
    statuses?: number[],
    searchText?: string,
    groupId?: string,
    clientId?: string,
    sortColumn?: string,
    sortOrder?: number
  }
}>())

const FETCH_MANAGE_SURVEY_LIST_SUCCESS = '[questionnaires] fetch manage survey list success';
export const FetchManageSurveyListSuccess = createAction(FETCH_MANAGE_SURVEY_LIST_SUCCESS, props<{ payload: FetchManageSurveyListResponse['response']['data'] }>())

const FETCH_MANAGE_SURVEY_LIST_FAILURE = '[questionnaires] fetch manage survey list failure';
export const FetchManageSurveyListFailure = createAction(FETCH_MANAGE_SURVEY_LIST_FAILURE,)


//fetch session list for create survey
const FETCH_SESSION_LIST_FOR_CREATE_SURVEY_REQUEST = '[questionnaires] fetch session list for create survey request'
export const FetchSessionListForCreateSurveyRequest = createAction(FETCH_SESSION_LIST_FOR_CREATE_SURVEY_REQUEST)

const FETCH_SESSION_LIST_FOR_CREATE_SURVEY_SUCCESS = '[questionnaires] fetch session list for create survey success'
export const FetchSessionListForCreateSurveySuccess = createAction(FETCH_SESSION_LIST_FOR_CREATE_SURVEY_SUCCESS, props<{ payload: { sessionList: DropdownOption[] } }>())

const FETCH_SESSION_LIST_FOR_CREATE_SURVEY_FAILURE = '[questionnaires] fetch session list for create survey failure'
export const FetchSessionListForCreateSurveyFailure = createAction(FETCH_SESSION_LIST_FOR_CREATE_SURVEY_FAILURE)


//fetch schedule according to list for create survey
const FETCH_SCHEDULE_ACCORDING_TO_LIST_FOR_CREATE_SURVEY_REQUEST = '[questionnaires] fetch schedule according to list for create survey request'
export const FetchScheduleAccordingToListForCreateSurveyRequest = createAction(FETCH_SCHEDULE_ACCORDING_TO_LIST_FOR_CREATE_SURVEY_REQUEST)

const FETCH_SCHEDULE_ACCORDING_TO_LIST_FOR_CREATE_SURVEY_SUCCESS = '[questionnaires] fetch schedule according to list for create survey success'
export const FetchScheduleAccordingToListForCreateSurveySuccess = createAction(FETCH_SCHEDULE_ACCORDING_TO_LIST_FOR_CREATE_SURVEY_SUCCESS, props<{ payload: { scheduleAccordingToList: DropdownOption[] } }>())

const FETCH_SCHEDULE_ACCORDING_TO_LIST_FOR_CREATE_SURVEY_FAILURE = '[questionnaires] fetch schedule according to list for create survey failure'
export const FetchScheduleAccordingToListForCreateSurveyFailure = createAction(FETCH_SCHEDULE_ACCORDING_TO_LIST_FOR_CREATE_SURVEY_FAILURE)


//add survey send schedule data
const ADD_SURVEY_SEND_SCHEDULE_DATA_REQUEST = '[questionnaires] add survey send schedule data request'
export const AddSurveySendScheduleDataRequest = createAction(ADD_SURVEY_SEND_SCHEDULE_DATA_REQUEST, props<{ payload: { scheduleFormData: CreateSurveyScheduleDetails['request'], mode: any, navigate: boolean } }>())

const ADD_SURVEY_SEND_SCHEDULE_DATA_SUCCESS = '[questionnaires] add survey send schedule data success'
export const AddSurveySendScheduleDataSuccess = createAction(ADD_SURVEY_SEND_SCHEDULE_DATA_SUCCESS, props<{ payload: any, message: string }>())

const ADD_SURVEY_SEND_SCHEDULE_DATA_FAILURE = '[questionnaires] add survey send schedule data failure'
export const AddSurveySendScheduleDataFailure = createAction(ADD_SURVEY_SEND_SCHEDULE_DATA_FAILURE)


//edit survey send schedule data
const EDIT_SURVEY_SEND_SCHEDULE_DATA_REQUEST = '[questionnaires] edit survey send schedule data request'
export const EditSurveySendScheduleDataRequest = createAction(EDIT_SURVEY_SEND_SCHEDULE_DATA_REQUEST, props<{ payload: { scheduleFormData: CreateSurveyScheduleDetails['request'], mode: any, surveyId: string, navigate: boolean } }>())

const EDIT_SURVEY_SEND_SCHEDULE_DATA_SUCCESS = '[questionnaires] edit survey send schedule data success'
export const EditSurveySendScheduleDataSuccess = createAction(EDIT_SURVEY_SEND_SCHEDULE_DATA_SUCCESS, props<{ payload: any, message: string }>())

const EDIT_SURVEY_SEND_SCHEDULE_DATA_FAILURE = '[questionnaires] edit survey send schedule data failure'
export const EditSurveySendScheduleDataFailure = createAction(EDIT_SURVEY_SEND_SCHEDULE_DATA_FAILURE)


//edit survey data
const EDIT_SURVEY_DATA_SURVEY_CONFIG_REQUEST = '[questionnaires] edit survey data for survey config request'
export const EditSurveyDataForSurveyConfigRequest = createAction(EDIT_SURVEY_DATA_SURVEY_CONFIG_REQUEST, props<{
  payload: {
    surveyId: string,
    config: any,
    status: any,
    mode: any,
    navigate: boolean
  }
}>());

const EDIT_SURVEY_DATA_SURVEY_CONFIG_SUCCESS = '[questionnaires] edit survey data for survey config success'
export const EditSurveyDataForSurveyConfigSuccess = createAction(EDIT_SURVEY_DATA_SURVEY_CONFIG_SUCCESS, props<{ payload: any, message: string }>());

const EDIT_SURVEY_DATA_SURVEY_CONFIG_FAILURE = '[questionnaires] edit survey data for survey config failure'
export const EditSurveyDataForSurveyConfigFailure = createAction(EDIT_SURVEY_DATA_SURVEY_CONFIG_FAILURE);


//fetch roles options
const FETCH_ROLES_OPTIONS_LIST_REQUEST = '[questionnaires] fetch roles' +
                                         ' options list request';
export const FetchRolesOptionsListRequest = createAction(FETCH_ROLES_OPTIONS_LIST_REQUEST,)

const FETCH_ROLES_OPTIONS_LIST_SUCCESS = '[questionnaires] fetch roles' +
                                         ' options list success';
export const FetchRolesOptionsListSuccess = createAction(FETCH_ROLES_OPTIONS_LIST_SUCCESS, props<{ payload: { list: DropdownOption[] } }>())

const FETCH_ROLES_OPTIONS_LIST_FAILURE = '[questionnaires] fetch roles' +
                                         ' options list failure';
export const FetchRolesOptionsListFailure = createAction(FETCH_ROLES_OPTIONS_LIST_FAILURE,)


//fetch clinics options
const FETCH_CLINICS_OPTIONS_LIST_REQUEST = '[questionnaires] fetch clinics options list request';
export const FetchClinicsOptionsListRequest = createAction(FETCH_CLINICS_OPTIONS_LIST_REQUEST, props<{ payload: { pageNumber: number, shouldInclude?: any[], search?:string } }>())

const FETCH_CLINICS_OPTIONS_LIST_SUCCESS = '[questionnaires] fetch clinics options list success';
export const FetchClinicsOptionsListSuccess = createAction(FETCH_CLINICS_OPTIONS_LIST_SUCCESS, props<{
  payload: {
    list: DropdownOption[],
    hasNext?: boolean,
    hasPrev?: boolean,
    limit?: number,
    pageNumber?: number,
    total?: number
  }
}>())

const FETCH_CLINICS_OPTIONS_LIST_FAILURE = '[questionnaires] fetch clinics options list failure';
export const FetchClinicsOptionsListFailure = createAction(FETCH_CLINICS_OPTIONS_LIST_FAILURE,)


//fetch groups options
const FETCH_GROUPS_OPTIONS_LIST_REQUEST = '[questionnaires] fetch groups options list request';
export const FetchGroupsOptionsListRequest = createAction(FETCH_GROUPS_OPTIONS_LIST_REQUEST, props<{ payload: { clientId: number[], pageNumber?: number, shouldInclude?: any[], search?: string} }>())

const FETCH_GROUPS_OPTIONS_LIST_SUCCESS = '[questionnaires] fetch groups options list success';
export const FetchGroupsOptionsListSuccess = createAction(FETCH_GROUPS_OPTIONS_LIST_SUCCESS, props<{ payload: {  list: DropdownOption[],
  total: number,
  pageNumber: number,
  limit: number,
  hasNext: boolean,
  hasPrev: boolean
 } }>())

const FETCH_GROUPS_OPTIONS_LIST_FAILURE = '[questionnaires] fetch groups options list failure';
export const FetchGroupsOptionsListFailure = createAction(FETCH_GROUPS_OPTIONS_LIST_FAILURE,)


//fetch groups status options
const FETCH_GROUPS_STATUS_OPTIONS_LIST_REQUEST = '[questionnaires] fetch group status options list request';
export const FetchGroupStatusOptionsListRequest = createAction(FETCH_GROUPS_STATUS_OPTIONS_LIST_REQUEST,)

const FETCH_GROUPS_STATUS_OPTIONS_LIST_SUCCESS = '[questionnaires] fetch group status options list success';
export const FetchGroupStatusOptionsListSuccess = createAction(FETCH_GROUPS_STATUS_OPTIONS_LIST_SUCCESS, props<{ payload: { list: DropdownOption[] } }>())

const FETCH_GROUPS_STATUS_OPTIONS_LIST_FAILURE = '[questionnaires] fetch group status options list failure';
export const FetchGroupStatusOptionsListFailure = createAction(FETCH_GROUPS_STATUS_OPTIONS_LIST_FAILURE,)


//fetch gender status options
const FETCH_GENDER_OPTIONS_LIST_REQUEST = '[questionnaires] fetch gender options list request';
export const FetchGenderOptionsListRequest = createAction(FETCH_GENDER_OPTIONS_LIST_REQUEST,)

const FETCH_GENDER_OPTIONS_LIST_SUCCESS = '[questionnaires] fetch gender options list success';
export const FetchGenderOptionsListSuccess = createAction(FETCH_GENDER_OPTIONS_LIST_SUCCESS, props<{ payload: { list: DropdownOption[] } }>())

const FETCH_GENDER_OPTIONS_LIST_FAILURE = '[questionnaires] fetch gender options list failure';
export const FetchGenderOptionsListFailure = createAction(FETCH_GENDER_OPTIONS_LIST_FAILURE,)

//edit survey dara
const EDIT_SURVEY_DATA_FOR_SURVEY_SEND_TO_REQUEST = '[questionnaires] edit survey data for survey send to request'
export const EditSurveyDataForSendToRequest = createAction(EDIT_SURVEY_DATA_FOR_SURVEY_SEND_TO_REQUEST, props<{
  payload: {
    surveyId: string,
    sendTo: any,
    status: number,
    mode: any,
    navigate: boolean,
    scheduleAccordingTo: any,
    activeFrom: any,
    activeTo: any
  }
}>());

const EDIT_SURVEY_DATA_FOR_SURVEY_SEND_TO_SUCCESS = '[questionnaires] edit survey data for survey send to success'
export const EditSurveyDataForSendToSuccess = createAction(EDIT_SURVEY_DATA_FOR_SURVEY_SEND_TO_SUCCESS, props<{ payload: any, message: string }>());

const EDIT_SURVEY_DATA_FOR_SURVEY_SEND_TO_FAILURE = '[questionnaires] edit survey data for survey send to failure'
export const EditSurveyDataForSendToFailure = createAction(EDIT_SURVEY_DATA_FOR_SURVEY_SEND_TO_FAILURE);


//fetch details by id
const FETCH_SURVEY_DETAILS_BY_ID_REQUEST = '[questionnaires] fetch survey details by id request';
export const FetchSurveyDetailsByIdRequest = createAction(FETCH_SURVEY_DETAILS_BY_ID_REQUEST, props<{ payload: { surveyId: string } }>())

const FETCH_SURVEY_DETAILS_BY_ID_SUCCESS = '[questionnaires] fetch survey details by id success';
export const FetchSurveyDetailsByIdSuccess = createAction(FETCH_SURVEY_DETAILS_BY_ID_SUCCESS, props<{ payload: { surveyDetails: any } }>())

const FETCH_SURVEY_DETAILS_BY_ID_FAILURE = '[questionnaires] fetch survey details by id failure';
export const FetchSurveyDetailsByIdFailure = createAction(FETCH_SURVEY_DETAILS_BY_ID_FAILURE)

//duplicate survey

const CREATE_DUPLICATE_SURVEY_REQUEST = '[questionnaires] create duplicate' +
                                        ' survey request'
export const CreateDuplicateSurveyRequest = createAction(CREATE_DUPLICATE_SURVEY_REQUEST, props<{ payload: { surveyId: string } }>())

const CREATE_DUPLICATE_SURVEY_SUCCESS = '[questionnaires] create duplicate' +
                                        ' survey success'
export const CreateDuplicateSurveySuccess = createAction(CREATE_DUPLICATE_SURVEY_SUCCESS, props<{ payload: { surveyDetails: any } }>())


const CREATE_DUPLICATE_SURVEY_FAILURE = '[questionnaires] create duplicate' +
                                        ' survey failure'
export const CreateDuplicateSurveyFailure = createAction(CREATE_DUPLICATE_SURVEY_FAILURE,)

//fetch questionnaire details for edit
const FETCH_QUESTIONNAIRE_DETAILS_FOR_EDIT_VIEW_REQUEST = '[questionnaires] fetch questionnaire details for edit view request'
export const FetchQuestionnaireDetailsForEditViewRequest = createAction(FETCH_QUESTIONNAIRE_DETAILS_FOR_EDIT_VIEW_REQUEST, props<{ payload: { surveyId: string } }>())

const FETCH_QUESTIONNAIRE_DETAILS_FOR_EDIT_VIEW_SUCCESS = '[questionnaires] fetch questionnaire details for edit view success'
export const FetchQuestionnaireDetailsForEditViewSuccess = createAction(FETCH_QUESTIONNAIRE_DETAILS_FOR_EDIT_VIEW_SUCCESS, props<{ payload: { surveyDetails: QuestionnaireDetails } }>())


const FETCH_QUESTIONNAIRE_DETAILS_FOR_EDIT_VIEW_FAILURE = '[questionnaires] fetch questionnaire details for edit view failure'
export const FetchQuestionnaireDetailsForEditViewFailure = createAction(FETCH_QUESTIONNAIRE_DETAILS_FOR_EDIT_VIEW_FAILURE)

//edit survey Data
const EDIT_SURVEY_DATA_FOR_EDIT_SCREEN_REQUEST = '[questionnaires] edit survey data for edit screen request'
export const EditSurveyDataForEditScreenRequest = createAction(EDIT_SURVEY_DATA_FOR_EDIT_SCREEN_REQUEST, props<{
  payload: { surveyDetails: QuestionnaireDetails }
}>())

const EDIT_SURVEY_DATA_FOR_EDIT_SCREEN_SUCCESS = '[questionnaires] edit survey data for edit screen success'
export const EditSurveyDataForEditScreenSuccess = createAction(EDIT_SURVEY_DATA_FOR_EDIT_SCREEN_SUCCESS, props<{
  payload: { surveyDetails: any },
  message?: string,
}>())

const EDIT_SURVEY_DATA_FOR_EDIT_SCREEN_FAILURE = '[questionnaires] edit survey data for edit screen failure'
export const EditSurveyDataForEditScreenFailure = createAction(EDIT_SURVEY_DATA_FOR_EDIT_SCREEN_FAILURE)


//close survey

const CLOSE_SURVEY_REQUEST = '[questionnaires] close survey request'
export const CloseSurveyRequest = createAction(CLOSE_SURVEY_REQUEST, props<{
  payload: { surveyId: number }
}>())

const CLOSE_SURVEY_SUCCESS = '[questionnaires] close survey success'
export const CloseSurveySuccess = createAction(CLOSE_SURVEY_SUCCESS)

const CLOSE_SURVEY_FAILURE = '[questionnaires] close survey failure'
export const CloseSurveyFailure = createAction(CLOSE_SURVEY_FAILURE)


//add survey response
const ADD_SURVEY_RESPONSE_REQUEST = '[questionnaires] add survey response request'
export const AddSurveyResponseRequest = createAction(ADD_SURVEY_RESPONSE_REQUEST, props<{
  payload: {
    surveyId: any,
    config: any
  }
}>());


const ADD_SURVEY_RESPONSE_SUCCESS = '[questionnaires] add survey response success'
export const AddSurveyResponseSuccess = createAction(ADD_SURVEY_RESPONSE_SUCCESS, props<{ message: string }>());

const ADD_SURVEY_RESPONSE_FAILURE = '[questionnaires] add survey response failure'
export const AddSurveyResponseFailure = createAction(ADD_SURVEY_RESPONSE_FAILURE);


//fetch survey response to  review by super Admin
const FETCH_SURVEY_RESPONSE_FOR_REVIEW_AND_EDIT_FOR_SUPER_ADMIN_REQUEST = '[questionnaires] fetch survey response for review for review and edit for super admin request'
export const FetchSurveyResponseForReviewAndEditForSuperAdminRequest = createAction(FETCH_SURVEY_RESPONSE_FOR_REVIEW_AND_EDIT_FOR_SUPER_ADMIN_REQUEST, props<{ payload: { surveyId: string, userId: string } }>())

const FETCH_SURVEY_RESPONSE_FOR_REVIEW_AND_EDIT_FOR_SUPER_ADMIN_SUCCESS = '[questionnaires] fetch survey response for review for review and edit for super admin success'
export const FetchSurveyResponseForReviewAndEditForSuperAdminSuccess = createAction(FETCH_SURVEY_RESPONSE_FOR_REVIEW_AND_EDIT_FOR_SUPER_ADMIN_SUCCESS, props<{ payload: { surveyDetails: SurveyReviewDetails } }>())

const FETCH_SURVEY_RESPONSE_FOR_REVIEW_AND_EDIT_FOR_SUPER_ADMIN_FAILURE = '[questionnaires] fetch survey response for review for review and edit for super admin failure'
export const FetchSurveyResponseForReviewAndEditForSuperAdminFailure = createAction(FETCH_SURVEY_RESPONSE_FOR_REVIEW_AND_EDIT_FOR_SUPER_ADMIN_FAILURE,)


//edit survey Response
const EDIT_SURVEY_RESPONSE_REQUEST = '[questionnaires] edit survey response request'
export const EditSurveyResponseRequest = createAction(EDIT_SURVEY_RESPONSE_REQUEST, props<{
  payload: {
    surveyId: any,
    config: any,
    forUserId: any
  }
}>());


const EDIT_SURVEY_RESPONSE_SUCCESS = '[questionnaires] edit survey response success'
export const EditSurveyResponseSuccess = createAction(EDIT_SURVEY_RESPONSE_SUCCESS, props<{ message: string }>());

const EDIT_SURVEY_RESPONSE_FAILURE = '[questionnaires] edit survey response failure'
export const EditSurveyResponseFailure = createAction(EDIT_SURVEY_RESPONSE_FAILURE, props<{ payload: { surveyId: any, forUserId: any } }>());

//fetch pending survey count
const FETCH_PENDING_SURVEY_COUNT_REQUEST = '[questionnaires] fetch pending survey count request';
export const FetchPendingSurveyCountRequest = createAction(FETCH_PENDING_SURVEY_COUNT_REQUEST);

const FETCH_PENDING_SURVEY_COUNT_SUCCESS = '[questionnaires] fetch pending survey count success';
export const FetchPendingSurveyCountSuccess = createAction(FETCH_PENDING_SURVEY_COUNT_SUCCESS, props<{ payload: { count: number } }>());

const FETCH_PENDING_SURVEY_COUNT_FAILURE = '[questionnaires] fetch pending survey count failure';
export const FetchPendingSurveyCountFailure = createAction(FETCH_PENDING_SURVEY_COUNT_FAILURE);

